import React from 'react';
import '../../Static/Master/PackPrintStruct.css';

const PackPrintStruct = ({ heading, leftData, rightData, middleData }) => {
    return (
        <div>
            {/* Heading */}
            <h3 className="heading">{heading}</h3>

            {/* Upper part: Two tables side by side */}
            <div className="flex-container">
                {/* Left Table */}
                <table>

                    <tbody>
                        {leftData &&
                            <>
                                <tr>
                                    <td><h2>{leftData.firm}</h2></td>
                                </tr>
                                <tr>
                                    <td>{leftData.adrs}</td>
                                </tr>
                                <tr>
                                    <td>{leftData.gst}</td>
                                </tr>
                                <tr>
                                    <td><h3>To:</h3></td>
                                    <td><h2>{leftData.party}</h2></td>
                                    <td>{leftData.party_adrs}</td>
                                </tr>
                            </>
                        }
                    </tbody>
                </table>

                {/* Right Table */}
                <table>

                    <tbody>
                        {rightData &&
                            <>
                                <tr>
                                    <td></td>
                                    {/* <td>Row {idx + 1} - Cell 2</td> */}
                                </tr>
                            </>
                        }

                    </tbody>
                </table>
            </div>

            {/* Main Table */}
            {/* <table className="main-table">
                <thead>
                    <tr>
                        {[...Array(8)].map((_, idx) => (
                            <th key={idx}>Column {idx + 1}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {[...Array(10)].map((_, idx) => (
                        <tr key={idx}>
                            {[...Array(8)].map((_, colIdx) => (
                                <td key={colIdx}>Row {idx + 1} - Cell {colIdx + 1}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table> */}

            {/* Footer */}
            {/* <div className="footer-flex-container">
                Left Footer Table
                <table>
                    <thead>
                        <tr>
                            <th>Column 1</th>
                            <th>Column 2</th>
                        </tr>
                    </thead>
                    <tbody>
                        {[...Array(4)].map((_, idx) => (
                            <tr key={idx}>
                                <td>Row {idx + 1} - Cell 1</td>
                                <td>Row {idx + 1} - Cell 2</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                Right Footer Table
                <table>
                    <thead>
                        <tr>
                            <th>Column 1</th>
                            <th>Column 2</th>
                        </tr>
                    </thead>
                    <tbody>
                        {[...Array(4)].map((_, idx) => (
                            <tr key={idx}>
                                <td>Row {idx + 1} - Cell 1</td>
                                <td>Row {idx + 1} - Cell 2</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div> */}
        </div>
    );
};

export default PackPrintStruct;
